import React, { useState } from "react";
import SideBox from "../pages/SideBox";

// css
import "../css/EurekaTrend.css";

// img
import eurekaVideo from "../assets/video/solutions_Eureka_video.mp4";

import icon1 from "../assets/img/eureka_icon1.png";
import icon2 from "../assets/img/eureka_icon2.png";
import icon03 from "../assets/img/trend_icon03.png";
import leftArrow from "../assets/img/eureka_left.png";
import rightArrow from "../assets/img/eureka_right.png";
import sec2_icon1 from "../assets/img/trend_sec2_icon1.png";
import sec2_icon2 from "../assets/img/trend_sec2_icon2.png";
import sec2_icon3 from "../assets/img/trend_sec2_icon3.png";
import sec2_icon4 from "../assets/img/trend_sec2_icon4.png";
import sec2_icon5 from "../assets/img/eureka_sec2_icon5.png";
import line01 from "../assets/img/sec2_line01.png";
import line02 from "../assets/img/sec2_line02.png";
import trend01 from "../assets/img/trend01.jpg";
import trend02 from "../assets/img/trend02.jpg";
import trend03 from "../assets/img/trend03.jpg";
import trend04 from "../assets/img/trend04.jpg";
import sec4Icon1 from "../assets/img/eureka_sec4_icon1.png";
import sec4Icon2 from "../assets/img/eureka_sec4_icon2.png";
import sec4Icon3 from "../assets/img/eureka_sec4_icon3.png";
import sec4Icon4 from "../assets/img/eureka_sec4_icon4.png";
import sec4Icon5 from "../assets/img/eureka_sec4_icon5.png";
import sec4Icon6 from "../assets/img/eureka_sec4_icon6.png";
import sec4Icon7 from "../assets/img/eureka_sec4_icon7.png";
import sec4Icon8 from "../assets/img/eureka_sec4_icon8.png";
import sec4Icon9 from "../assets/img/eureka_sec4_icon9.png";
import dotLine from "../assets/img/sec4_dot_line.png";
import downIcon1 from "../assets/img/down_icon1.png";
import downIcon2 from "../assets/img/down_icon2.png";
import downIcon3 from "../assets/img/down_icon3.png";
import downIcon4 from "../assets/img/down_icon4.png";

export default function Trend() {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div className="eureka_main">
      <SideBox />

      <header className="eureka_header">
        <div className="bg_black"></div>
        <video muted autoPlay loop>
          <source src={eurekaVideo} type="video/mp4" />
        </video>

        <div className="header_text center">
          <div className="text">
            <h3>기업에서 필요한 정보를 한눈에 살펴보세요​</h3>
            <h1>
              트렌드 주도 데이터 자동화 솔루션
              <br />
              Trend Sensing Board
            </h1>
          </div>

          <div className="header_btn">
            <a
              href="http://file.rbrain.co.kr/2025-09-12T05-20-18-877Z-%EB%B8%8C%EB%A1%9C%EC%85%94_%EC%9C%A0%EB%A0%88%EC%B9%B4%EB%B8%8C%EB%A0%88%EC%9D%B8%26%ED%8A%B8%EB%A0%8C%EB%93%9C%EC%84%BC%EC%8B%B1%EB%B3%B4%EB%93%9C.pdf"
              className="btn_left"
              target="_blank"
              rel="noreferrer"
            >
              서비스 소개서
            </a>
            <a
              href="https://rbrain.co.kr/company/support"
              target="_blank"
              rel="noreferrer"
            >
              이용 문의
            </a>
          </div>

          <div id="scroll">
            <p>Scroll down</p>
            <div onClick={(e) => e.preventDefault()} className="scroll">
              <span></span>
            </div>
          </div>
        </div>
      </header>

      <main>
        {/* Section 1 */}
        <section id="sec1">
          <div className="center">
            <div>
              <h3>Trend Sensing Board</h3>
              <h2>서비스 소개</h2>
            </div>
            <div className="sec1_box">
              <div className="box">
                <img src={icon2} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  365일 24시간 변화하는 트렌드 정보를
                  <br />
                  매일 자동으로 수집하고 파악할 수 있다면
                </p>
              </div>
              <div className="box">
                <img src={icon1} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  다양한 종류의 데이터를
                  <br />
                  한눈에 확인할 수 있다면
                </p>
              </div>
              <div className="box">
                <img src={icon03} alt="아이콘 이미지아이콘 이미지" />
                <p>
                  방대한 데이터를 요약하여
                  <br />
                  한눈에 요점만 파악할 수 있다면
                </p>
              </div>
            </div>
            <div>
              <p className="main_text">
                <img
                  src={leftArrow}
                  alt="아이콘 이미지화살표 이미지"
                  className="arr_left"
                />
                데이터 기반의 Trend Sensing Board을 활용하여
                <br />
                트렌드를 미리 예측하고 미래의 기회를 발견하세요!
                <img
                  src={rightArrow}
                  alt="아이콘 이미지화살표 이미지"
                  className="arr_right"
                />
              </p>
              <p className="sub_text">
                다양한 데이터 소스를 수집하고 활용함으로써
                <br />
                새로운 트렌드를 감지하기 위한 기회를 마련할 수 있습니다.
                <br />
                이런 데이터 수집은 물론 시각화까지 많은 인적 자원과 시간이
                필요합니다.
              </p>
            </div>
            <div className="box2_bg">
              <p>
                Trend Sensing Board는 탁월한 데이터 시각화를 제공하여
                <br />
                고객들이 트렌드를 더 효과적으로 파악하고 분석할 수 있도록
                지원합니다.
                <br />
                <span>
                  현재와 미래를 더 명확하게 이해하고 높은 수준의 비즈니스 결정을
                  도와드립니다.
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* Section 2 */}
        <section id="sec2">
          <div className="center">
            <div>
              <h3>Trend Sensing Board</h3>
              <h2>주요 기능</h2>
            </div>
            <div>
              <div className="sec2_box">
                <div className="box">
                  <div className="num">01</div>
                  <img src={sec2_icon1} alt="아이콘 이미지" />
                  <p>
                    업계 동향을 파악할 수 있는
                    <br />
                    국내외 주요 뉴스
                    <br />
                    요약 정보 제공
                  </p>
                </div>
                <div className="box">
                  <div className="num">02</div>
                  <img src={sec2_icon2} alt="아이콘 이미지" />
                  <p>
                    연관 금융 지수,
                    <br />
                    경제 지표 등을
                    <br />
                    한눈에 제공
                  </p>
                </div>
                <div className="box" style={{ marginRight: "20px" }}>
                  <div className="num">03</div>
                  <img src={sec2_icon3} alt="아이콘 이미지" />
                  <p>
                    비즈니스 결정에 필요한
                    <br />
                    특허 및 법규, 규제 등
                    <br />
                    정보 제공
                  </p>
                </div>
                <div className="box">
                  <div className="num">04</div>
                  <img src={sec2_icon4} alt="아이콘 이미지" />
                  <p>
                    투자 현황을 파악하기 위한
                    <br />
                    키워드별 투자 정보 제공 및
                    <br />
                    기업보고서 연결
                  </p>
                </div>
                <div className="box">
                  <div className="num">05</div>
                  <img src={sec2_icon5} alt="아이콘 이미지" />
                  <p>
                    실시간 인기 검색어,
                    <br />
                    해당 연관 검색어,
                    <br />
                    해당 키워드 검색량 등 제공
                  </p>
                </div>
              </div>
            </div>
            <div className="sec2_box2_wrap">
              <div className="box2_left">
                <div className="box2_main_text">Technology</div>
                <div>
                  <div className="cE6F9FF_wrap">
                    <div className="cE6F9FF">
                      RPA
                      <br />
                      (Robotic Process Automation,
                      <br />
                      업무 처리 자동화)
                    </div>
                    <div className="cE6F9FF">
                      web crawling
                      <br />
                      (데이터 자동 수집)
                    </div>
                  </div>
                  <div className="cE6F9FF_wrap">
                    <div className="cE6F9FF">
                      언제 어디서나 사용 가능한
                      <br />
                      SaaS 방식 서비스
                    </div>
                    <div className="cE6F9FF">
                      Multi Cloud를 지원하는
                      <br />
                      Cloud Native Platform
                    </div>
                  </div>
                </div>
              </div>
              <div className="box2_center trend_box_center">
                <img src={line01} alt="아이콘 이미지라인 이미지" />
                <div>
                  Trend
                  <br />
                  Sensing
                  <br />
                  Board
                </div>
                <img src={line02} alt="아이콘 이미지라인 이미지" />
              </div>
              <div className="box2_right">
                <div>
                  <div className="box2_main_text2">Service</div>
                  <div className="cE9EBFF">트렌드 관련 데이터 수집</div>
                  <div className="cE9EBFF">기간별 대량 데이터 요약</div>
                  <div className="cE9EBFF">분석 데이터 시각화</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3 */}
        <section id="sec3" className="trend_sec3">
          <div className="center">
            <div>
              <h3>Trend Sensing Board</h3>
              <h2>서비스 특징</h2>
            </div>

            <div className="tab_menu">
              <ul className="tab_list">
                <li className={activeTab === 1 ? "is_on" : ""}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setActiveTab(1)}
                  >
                    업계 동향 및 경쟁 정보 요약
                  </button>
                  {activeTab === 1 && (
                    <div className="cont trend_cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>뉴욕 타임즈, 구글, 네이버
                          등 산업분류와 키워드에 따른 주요 뉴스를 한번에 볼 수
                          있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>수집된 뉴스를 요약하여
                          전문을 읽지 않더라도 전체 내용을 파악할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>서비스를 사용하는 고객
                          기준으로 뉴스 내용의 긍 · 부정 및 중요도를 제공하여
                          얼마나 영향력 있는 뉴스인지 확인합니다.
                        </p>
                        <p>
                          <span className="dot"></span>수집된 뉴스의 주요 키워드
                          및 노출 키워드를 시각화하여 볼 수 있습니다.
                        </p>
                      </div>
                      <div className="trend_img">
                        <img src={trend01} alt="아이콘 이미지이미지" />
                      </div>
                    </div>
                  )}
                </li>

                <li className={activeTab === 2 ? "is_on" : ""}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setActiveTab(2)}
                  >
                    금융 및 시장 현황 파악
                  </button>
                  {activeTab === 2 && (
                    <div className="cont trend_cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>기획재정부에서 제공하는
                          일일 금융 지수 관련 정보를 확인할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>기업과 관련 있는 주식 및
                          경제 지표 정보를 한눈에 살펴보고 현황을 파악할 수
                          있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>AI 분석을 통해 분석된
                          주식 흐름 요약 정보를 제공 받을 수 있습니다.
                        </p>
                      </div>
                      <div className="trend_img">
                        <img src={trend02} alt="아이콘 이미지이미지" />
                      </div>
                    </div>
                  )}
                </li>

                <li className={activeTab === 3 ? "is_on" : ""}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setActiveTab(3)}
                  >
                    특허, 법규, 투자 등
                    <br />
                    최신 연관 정보 제공
                  </button>
                  {activeTab === 3 && (
                    <div className="cont trend_cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>기업과 관련된 키워드로
                          국내 · 해외 특허 및 요약 정보를 한 곳에서 확인할 수
                          있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>국내 · 해외에 공시된 법규
                          정보 및 규제 정보를 파악할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>국내 투자 유치 현황 및
                          증권사에서 제공하는 기업 분석 리포트에 쉽게 접근할 수
                          있습니다.
                        </p>
                      </div>
                      <div className="trend_img">
                        <img src={trend03} alt="아이콘 이미지이미지" />
                      </div>
                    </div>
                  )}
                </li>

                <li className={activeTab === 4 ? "is_on" : ""}>
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setActiveTab(4)}
                  >
                    소셜 트렌드 현황 확인
                  </button>
                  {activeTab === 4 && (
                    <div className="cont trend_cont">
                      <div className="tab_text">
                        <p>
                          <span className="dot"></span>실시간 인기 검색어 및
                          해당 연관 검색어와 검색량을 파악할 수 있습니다.
                        </p>
                        <p>
                          <span className="dot"></span>국내 주요 IT 행사 일정과
                          해외 Tech 관련 콘텐츠를 제공 받을 수 있습니다.
                        </p>
                      </div>
                      <div className="trend_img">
                        <img src={trend04} alt="아이콘 이미지이미지" />
                      </div>
                    </div>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Section 4 */}
        <section id="sec4" style={{ paddingBottom: "100px" }}>
          <div className="center">
            <div>
              <h3>Trend Sensing Board</h3>
              <h2>기대효과</h2>
            </div>

            <div>
              <div>
                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon1} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      시장 동향과 경제 지표를 통한 최신 데이터 기반 의사결정 및
                      전략 기획
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon2} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      기업의 비전과 목표에 맞는 트렌드 파악 및 기업 운영 방향
                      결정
                    </p>
                  </div>
                </div>

                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon3} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      새로운 트렌드 파악 및 시장 동향 파악을 통한 비즈니스
                      포지션 선택
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon4} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      경제 지표와 산업 동향 분석을 통한 비즈니스 리스크 최소화
                    </p>
                  </div>
                </div>

                <div className="box_wrap">
                  <div className="box">
                    <img src={sec4Icon5} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      정책 변화, 국제 경제 상황 등 분석을 통한 국내외 산업 동향
                      이해도 향상
                    </p>
                  </div>
                  <div className="box">
                    <img src={sec4Icon6} alt="아이콘 이미지아이콘 이미지" />
                    <p>
                      실시간 검색어를 통한 현 사회 이슈 확인 및 연관 주제 파악
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className="dot_line">
                  <img src={dotLine} alt="아이콘 이미지도트 라인 이미지" />
                </div>

                <div>
                  <div className="box2_wrap">
                    <div className="box2">
                      <img src={sec4Icon7} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c7959AE">데이터 수집 자동화</h5>
                      <p>자동화에 따른 효율적인 인적 자원 및 시간 배분</p>
                    </div>
                    <div className="box2">
                      <img src={sec4Icon8} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c5069C1">비즈니스 경쟁력 강화</h5>
                      <p>데이터 수집 자동화를 통한 발빠른 트렌드 분석</p>
                    </div>
                    <div className="box2">
                      <img src={sec4Icon9} alt="아이콘 이미지아이콘 이미지" />
                      <h5 className="c327EA8">데이터 기반 의사결정</h5>
                      <p>데이터 분석을 통해 최적의 의사결정 가능</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="down_btn">
                <a
                  href="https://tsb.today/"
                  className="btn_left"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={downIcon1} alt="아이콘 이미지" />
                  <p>서비스 체험하기</p>
                  <img src={downIcon2} alt="아이콘 이미지" />
                </a>

                <a
                  href="https://rbrain.co.kr/company/support"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={downIcon3} alt="아이콘 이미지" />
                  <p>비용 문의</p>
                  <img
                    src={downIcon4}
                    alt="아이콘 이미지"
                    style={{ transform: "rotate(270deg)" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
